module.exports = __webpack_public_path__ + "static/media/pic4.8b0033c9.jpg";